import { useEffect, useState } from 'react';
import { getLatestManualPrice, type ManualPriceRequestView } from '../manual-pricing.api';

/** The job's latest off-card request, read only while the job still needs a price (gitaumoses4/chukua#35). `setRequest` keeps it current after a submit or a decision. */
export function useLatestManualPrice(jobId: string, pricingRequired: boolean) {
  const [request, setRequest] = useState<ManualPriceRequestView | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!pricingRequired) return;
    let cancelled = false;
    getLatestManualPrice(jobId)
      .then((latest) => {
        if (cancelled) return;
        setRequest(latest);
        setIsLoaded(true);
      })
      .catch(() => {
        if (!cancelled) setIsLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [jobId, pricingRequired]);

  return { request, isLoaded, setRequest };
}
